import { Button, Col, DatePicker, Form, Row } from "antd";
import { setAppLoading } from "app/slices/appSlice";
import BieuDo from "components/bieuDo";
import FillterTable from "components/FillterTable";
import { PopUpAddGraphical } from "components/popupAddGraphical";
import RenderForm from "components/renderForm";
import TablePagination from "components/TablePagination";
import dayjs from "dayjs";
import { exportTableToExcelNew } from "helpers";
import { ConverData, ConverDataName } from "helpers/dataToAntdSelect";
import { useEffect, useMemo, useState } from "react";
import { useQueries } from "react-query";
import { useDispatch } from "react-redux";
import { getAppVersions, getAudiences, getCampaigns, getPaymentChannels, getPlatforms, getServicePackages, getServices, getStaffs, getTransactionTypes } from "services/apiRequest";
import { _exportHistory, getDataStatisticsRevenueReport, getGraphicalStatisticsRevenueReport } from "services/revenueReportRequest";

const rangePresets = [
    {
        label: '7 ngày trước',
        value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
        label: '14 ngày trước',
        value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
        label: '30 ngày trước',
        value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
        label: '90 ngày trước',
        value: [dayjs().add(-90, 'd'), dayjs()],
    },
];

export default function BaoCaoDoanhThu() {

    const serviceTypeIds = [{ value: 1, label: 'Dịch vụ 1:1' }, { value: 2, label: 'Dịch vụ InApp' }];

    const dispatch = useDispatch();

    const [form] = Form.useForm();

    const [tableFields, setTableFields] = useState({ metricIds: [1, 2], dimensionIds: [1] });

    const [{ data: dataPaymentChannels }, { data: dataServices }, { data: dataServicePackages },
        { data: dataTransactionTypes }, { data: dataCampaigns }, { data: dataPlatforms },
        { data: dataStaffs }, { data: dataAppVersions }, { data: dataAudiences }] = useQueries([
            {
                queryKey: ["dataPaymentChannels"],
                queryFn: () => getPaymentChannels(),
            },
            {
                queryKey: ["dataServices"],
                queryFn: () => getServices(),
            },
            {
                queryKey: ["dataServicePackages"],
                queryFn: () => getServicePackages([]),
            },
            {
                queryKey: ["dataTransactionTypes"],
                queryFn: () => getTransactionTypes(),
            },
            {
                queryKey: ["dataCampaigns"],
                queryFn: () => getCampaigns(),
            },
            {
                queryKey: ["dataPlatforms"],
                queryFn: () => getPlatforms(),
            },
            {
                queryKey: ["dataStaffs"],
                queryFn: () => getStaffs(),
            },
            {
                queryKey: ["dataAppVersions"],
                queryFn: () => getAppVersions(),
            },
            {
                queryKey: ["dataAudiences"],
                queryFn: () => getAudiences(),
            },
        ]);
    const [dataExport, setDataExport] = useState(null);

    const [graphical, setGraphical] = useState(null);

    const watchForm = Form.useWatch([], form);

    const listGoiDichVu = useMemo(() => {
        if (!watchForm) {
            return dataServicePackages?.data;
        }

        const { serviceIds, servicePackageIds } = watchForm;

        if (serviceIds?.length == 0) {
            return dataServicePackages?.data;
        }

        const dataCompare = [...dataServicePackages?.data];

        const data = dataCompare.filter(item => serviceIds.includes(+item.service_id));

        const idServicePackageIds = data.map(item => +item.id);

        // Kiểm tra phần tử trong idServicePackageIds không thuộc trong data và không phải 0
        const invalidIds = servicePackageIds.filter(item => !idServicePackageIds.includes(item));

        const hasInvalidIds = invalidIds.length > 0; // Kiểm tra nếu có id không hợp lệ

        if (hasInvalidIds) {
            form.setFieldValue("servicePackageIds", []);
        }

        return data;

    }, [watchForm?.serviceIds]);

    const setUpFormModal = [
        {
            name: 'range-time',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: "DD/MM/YYYY",
                presets: rangePresets
                // showSearch: true,
                // allowClear: true
            },
            label: 'Thời gian giao dịch',
        },
        {
            name: 'serviceTypeIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Loại dịch vụ',
            options: serviceTypeIds,
        },
        {
            name: 'serviceIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Dịch vụ',
            options: ConverData(dataServices?.data || []),
        },
        {
            name: 'servicePackageIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Gói dịch vụ',
            options: ConverData(listGoiDichVu || dataServicePackages?.data || []),
        },
        {
            name: 'paymentChannelIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Kênh thanh toán',
            options: ConverData(dataPaymentChannels?.data || []),
        },
        {
            name: 'transactionTypeIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Loại giao dịch',
            options: ConverData(dataTransactionTypes?.data || []),
        },
        {
            name: 'campaignIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Chiến dịch',
            options: ConverData(dataCampaigns?.data || []),
        },
        {
            name: 'platformIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Nơi ghi nhận giao dịch',
            options: ConverData(dataPlatforms?.data || []),
        },
        {
            name: 'staffIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Nhân viên chăm sóc',
            options: ConverData(dataStaffs?.data || []),
        },
        {
            name: 'audienceIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                // mode: 'multiple',
            },
            label: 'Tập khách hàng',
            options: ConverData(dataAudiences?.data || []),
        },
        {
            name: 'appVersions',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Phiên bản ứng dụng',
            options: ConverDataName(dataAppVersions?.data || []),
        },
        {
            type: "html",
            lg: 3,
            content: (
                <Row className={"flex justify-start items-end content-end h-full"}>
                    <Button type="primary"
                        onClick={() => {
                            form.submit();
                        }}
                    >Áp dụng</Button>
                </Row>
            ),
        },
    ];

    const [whereCondition, setWhereCondition] = useState({
        startTime: dayjs().subtract(30, 'days').format("DD/MM/YYYY"),
        endTime: dayjs().format("DD/MM/YYYY"),
        paymentChannelIds: [],
        serviceIds: [],
        servicePackageIds: [],
        transactionTypeIds: [],
        platformIds: [],
        campaignIds: [],
        staffIds: [],
        serviceTypeIds: [],
        appVersions: [],
        audienceIds: [],
        // metricIds: [1, 2],
        // dimensionIds: [1, 2]
    });

    useEffect(() => {

        let initialValues = Object.assign({}, whereCondition);

        const startTime = dayjs(initialValues.startTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.startTime, 'DD/MM/YYYY') : null;
        const endTime = dayjs(initialValues.endTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.endTime, 'DD/MM/YYYY') : null;

        initialValues['range-time'] = [startTime, endTime];

        form.setFieldsValue(initialValues);
    }, []);

    async function exportLichSu(values) {
        dispatch(setAppLoading(true));
        await _exportHistory(Object.assign({}, whereCondition));
        dispatch(setAppLoading(false));
    }

    return (
        <div className="px-7">
            <div className="flex flex-col gap-5 p-7 card">
                <div className="flex items-center justify-items-center justify-between">
                    <h1>
                        <b>BÁO CÁO DOANH THU</b>
                    </h1>

                    <div className="flex justify-content-end gap-3">
                        <Button
                            type="primary"
                            onClick={() => {
                                exportTableToExcelNew(dataExport, "BaoCaoDoanhThu");
                            }}
                        >
                            Export
                        </Button>
                        <PopUpAddGraphical
                            metricId={1}
                            dimensionId={1}
                            addDataFields={values => {
                                const newValues = { ...values };
                                setGraphical(newValues);
                            }}
                        />
                    </div>
                </div>

                <RenderForm
                    onFinish={(values) => {
                        let dataQueries = {};

                        Object.keys(values).map(key => {
                            const item = values[key];
                            if (key == "range-time") {

                                const startTime = dayjs(item[0]).format('DD/MM/YYYY');
                                const endTime = dayjs(item[1]).format('DD/MM/YYYY');

                                dataQueries.startTime = startTime;
                                dataQueries.endTime = endTime;
                            } else if (key == "audienceIds") {
                                if (item && !Array.isArray(item)) {
                                    dataQueries[key] = [item];
                                } else {
                                    dataQueries[key] = [];
                                }
                            } else {
                                if (item) {
                                    dataQueries[key] = item;
                                } else {
                                    dataQueries[key] = [];
                                }
                            }
                        })
                        setWhereCondition(dataQueries);
                    }}
                    form={form}
                    fields={setUpFormModal}
                    footer={<></>}
                />

                <BieuDo
                    metricId={1}
                    dimensionId={1}
                    whereCondition={whereCondition}
                    apiCallBack={getGraphicalStatisticsRevenueReport}
                    dataFields={[{ metricIds: [1], dimensionIds: [null] }, { metricIds: [2], dimensionIds: [null] }]}
                    addGraphical={graphical}
                />

                <div className="flex w-full">
                    <Row className="w-full" justify="space-between" gutter={[10, 10]}>
                        <Col span={20}>
                            <TablePagination
                                allowCreateAudience={true}
                                apiCallBack={getDataStatisticsRevenueReport}
                                whereCondition={whereCondition}
                                dataFields={tableFields}
                                dataTableChange={values => {
                                    setDataExport(values);
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <FillterTable
                                metricId={1}
                                dimensionId={1}
                                dataFields={tableFields}
                                onFieldsChange={values => {
                                    setTableFields(values);
                                }}
                            />
                        </Col>
                    </Row>
                </div>

                <Row>
                    <p className='underline cursor-pointer'
                        onClick={() => {
                            exportLichSu();
                        }}
                    >
                        <b>
                            Export lịch sử giao dịch
                        </b>
                    </p>
                </Row>
            </div>
        </div>
    )
}